import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { PoliciesFailure, PoliciesRequest, PoliciesSuccess } from './actions';
import { PolicyClient } from '@models/swagger';

export const featureKey = 'policies';

export interface State {
  data: PolicyClient[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(PoliciesFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(PoliciesRequest, state => ({ ...state, error: null, loading: true })),
    on(PoliciesSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
